/**
 * Refresco de sesión en rutas /user-zone/* (incluye hijas como /bookings).
 * Debe ser global: el meta `middleware: ['auth']` del padre no siempre aplica a esas hijas.
 * No hacer esto con top-level await en el layout: rompe el contexto Nuxt en el SSR de las hijas.
 *
 * Solo en cliente: evita sesión/HTML desalineados en el primer pintado.
 * Si el usuario confirma el correo en otra pestaña, user-zone.vue refresca al volver con visibilitychange.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.includes('/user-zone')) return
  if (!import.meta.client) return

  const { loggedIn } = useUserSession()
  if (!loggedIn.value) return

  const { refreshUserSession } = useByhoursSessionRefresh()
  await refreshUserSession()
})
